import { getCardRegistry } from '@/lib/cards';
import { IdentityCard } from './IdentityCard';
import { SubscriptionCard } from './SubscriptionCard';
import { MicrosoftPermissionsCard } from './MicrosoftPermissionsCard';
import { GmailConnectionCard } from './GmailConnectionCard';
import { InboxToolsCard } from './InboxToolsCard';
import { GraphWebhooksCard } from './GraphWebhooksCard';
import { VersionCard } from './VersionCard';

/**
 * Register all profile card components
 * Call this during app initialization
 */
export function registerProfileCardComponents() {
  const registry = getCardRegistry();

  registry.register('profile.identity', IdentityCard);
  registry.register('profile.subscription', SubscriptionCard);
  registry.register('profile.microsoft_permissions', MicrosoftPermissionsCard);
  registry.register('profile.gmail_connection', GmailConnectionCard);
  registry.register('profile.inbox_tools', InboxToolsCard);
  registry.register('profile.graph_webhooks', GraphWebhooksCard);
  registry.register('profile.version', VersionCard);
}

export { IdentityCard, SubscriptionCard, MicrosoftPermissionsCard, GmailConnectionCard, InboxToolsCard, GraphWebhooksCard, VersionCard };
